// extracted by mini-css-extract-plugin
export default {"scrollableContent":"Popup_scrollableContent__ec27o"};